module.exports = __webpack_public_path__ + "static/media/team@2x.82047b75.png";